export default __webpack_public_path__ + "static/media/f.29c4db30.jpg";